import { graphql } from 'gql'

export const YIELDBIRD_DEMAND_REPORT = graphql(`
  fragment YieldbirdDemandReport on Workspace {
    id
    yieldbirdDemandReportUrl
    users {
      id
      email
    }
  }
`)
